import moment from 'moment'
import React from 'react'
import DateTime from 'react-datetime'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import AdvancedTable from '../../Components/AdvancedTable'
import Expired from '../../Containers/CronReport/Expired'
import ManageAttractions from '../../Containers/CronReport/ManageAttractions'
import Whitelist from '../../Containers/CronReport/Whitelist'
import cronReportActions from '../../Redux/CronReportRedux'

class CronReport extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'YYYY-MM-DD'
    this.now = moment().format(this.dateFormat)
    this.state = {
      showModal: null,
      filter: {
        include_status: true,
        page: 1,
        limit: 10,
        item_page: 1,
        item_limit: 10,
        date: this.now
      },
      detail: [],
      selectedID: ''
    }
  }

  componentDidMount = () => {
    this.props.get(this.state.filter)
  }

  _changeDate = (date) => {
    let filter = { ...this.state.filter }
    filter.date = date.format(this.dateFormat)
    this.setState({ filter })
    setTimeout(() => {
      this.props.get(filter)
    }, 250)
  }

  _toggleModal = (id) => {
    if (!id) {
      this.setState({
        showModal: null,
        detail: []
      })
    } else {
      this.setState({ showModal: id })
    }
  }

  _selectItem = (item, modalID, id) => {
    this.setState({ detail: item, selectedID: id })
    this._toggleModal(modalID)
  }

  _viewModalButton = (buttonStyle, faStyle, name, item, modalID, id) => {
    return (
      <button
        className={`btn ${buttonStyle}`}
        onClick={() => this._selectItem(item, modalID, id)}
      >
        <i className={`fa ${faStyle} mr-2`} />{name}
      </button>
    )
  }

  render () {
    const { cronReport } = this.props
    return (
      <section className='section'>
        <header className='title-block'>
          <div className='d-flex justify-content-between'>
            <h1 className='title'>
              Cron Report Tools
              {
                (cronReport.fetching || cronReport.processing) &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h1>
            { this._viewModalButton('btn btn-primary', 'fa-cogs', 'Manage Whitelist', null, 'WHITELIST', null) }
          </div>
          {
            !(cronReport.processing || cronReport.fetching) && cronReport.err &&
            <div className='alert alert-danger'>{cronReport.err}</div>
          }
        </header>
        <div className='mt-3 mb-3'>
          <div className='row'>
            <div className='col-3'>
              <label className='control-label'>
                Change Date
              </label>
            </div>
            <div className='col-6'>
              <DateTime
                value={this.state.filter.date}
                dateFormat={this.dateFormat}
                timeFormat={false}
                isValidDate={(current) => current.isBefore(moment())}
                onChange={(date) => this._changeDate(date)}
                closeOnSelect
              />
            </div>
          </div>
        </div>
        <AdvancedTable
          colSpan={6}
          header={[
            { field: 'Provider' },
            { field: 'Created At' },
            { field: 'Date' },
            { field: 'Manage Attractions' },
            { field: 'Expired Attractions' }
          ]}
          body={
            cronReport.data.data &&
            cronReport.data.data.length > 0 &&
            cronReport.data.data.map((item, i) => ([
              { field: item.provider },
              { field: moment.unix(item.created_at).format('h:mm:ss a') },
              { field: item.date },
              { field: this._viewModalButton('btn btn-primary', 'fa-wrench', 'Manage', item.list_ids, 'MANAGE_ATTRACTION', item.id) },
              { field: this._viewModalButton('btn btn-info', 'fa-eye', 'View', item.expired_ids, 'EXPIRED_LIST', item.id) }
            ]))
          }
        />

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'MANAGE_ATTRACTION'} onClose={() => this._toggleModal(null)}>
          <ManageAttractions closeModal={() => this._toggleModal(null)} {...this.props} id={this.state.selectedID} filter={this.state.filter} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'WHITELIST'} onClose={() => this._toggleModal(null)}>
          <Whitelist closeModal={() => this._toggleModal(null)} {...this.props} />
        </Modal>

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'EXPIRED_LIST'} onClose={() => this._toggleModal(null)}>
          <Expired closeModal={() => this._toggleModal(null)} {...this.props} detail={this.state.detail} />
        </Modal>

      </section>
    )
  }
}

const stateToProps = (state) => ({
  cronReport: state.cronReport
})

const dispatchToProps = (dispatch) => ({
  get: (data) => dispatch(cronReportActions.getCronReportRequest(data)),
  getItem: (data) => dispatch(cronReportActions.getCronReportItemRequest(data)),
  disable: (data) => dispatch(cronReportActions.disableAttractionRequest(data)),
  enable: (data) => dispatch(cronReportActions.enableAttractionRequest(data)),
  getWhitelist: (data) => dispatch(cronReportActions.getWhitelistRequest(data)),
  putWhitelist: (data) => dispatch(cronReportActions.putWhitelistRequest(data)),
  deleteWhitelist: (data) => dispatch(cronReportActions.deleteWhitelistRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CronReport)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/CronReport.js